import { Flex } from "@capioweb/ui-components/src"
import React from "react"
import { BreadcrumbsBlock } from "../../components"
import { SharedFormProps } from "../../@types/CapioWeb/core"
import {
	PageBaseProps,
	BreadcrumbItemProps,
} from "../../components/Core/pageBase"
import {
	RegistrationFormContext,
	RegistrationFormContextProvider,
} from "./context/RegistrationFormContext"
import { RegistrationForm } from "./Form"

interface MyPagesUserRegistrationPage extends PageBaseProps {
	breadcrumb: Array<BreadcrumbItemProps>
	registrationForm: SharedFormProps
	interestsForm?: SharedFormProps
}

const MyPagesUserRegistrationPage: React.FC<MyPagesUserRegistrationPage> = ({
	breadcrumb,
	registrationForm,
	interestsForm,
}) => {
	const { setActiveFormVariant } = React.useContext(RegistrationFormContext)
	const defaultFormVariant = "registrationForm"
	React.useEffect(() => {
		setActiveFormVariant(defaultFormVariant)
	}, [setActiveFormVariant])
	return (
		<Flex display="block" w={1}>
			<BreadcrumbsBlock items={breadcrumb} />
			<Flex w={1} py={8} px={3} backgroundColor="greyEE">
				<RegistrationFormContextProvider
					defaultFormVariant={defaultFormVariant}
				>
					<RegistrationForm
						forms={{
							registrationForm,
							interestsForm,
						}}
					/>
				</RegistrationFormContextProvider>
			</Flex>
		</Flex>
	)
}

export { MyPagesUserRegistrationPage }
